class DayTallyController extends AbstractController
	@register()
	@inject '$uibModal',
		'DayTallyRepository'
		'RenderRepository'
		'SEARCH_CONFIGURATION'
		'CopyService'
		'BACKEND_SUBSCRIBER_ENTITY_TYPE'

	initialize: ->
		@subscriptionKey = @BACKEND_SUBSCRIBER_ENTITY_TYPE.DAY_TALLY
		@filterDTO = new FilterDTO({
			searchConfiguration: @SEARCH_CONFIGURATION.day_tally,
			sortProperty: 'start_time'
			itemsCount: 0
		})

		@dayTallies = []

	search: ->
		@searching = true

		query = @filterDTO.getQuery()
		query.with('shop', 'register')

		@DayTallyRepository
			.findByQuery query
			.then (response) =>
				@dayTallies = response.data
				@filterDTO.itemsCount = @dayTallies.length
				@searching = false
